import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { take } from 'rxjs';
import {
  NewsBannerModel,
  NewsBannerSlideModel,
} from '../../../../models/news-banner.model';
import { AlertService } from '../../../../services/alert.service';
import { NewsBannerService } from '../../../../services/news-banner.service';
import { ConfirmDialogComponent } from '../../../shared-components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-news-banners',
  templateUrl: './news-banners.component.html',
  styleUrl: './news-banners.component.scss',
  standalone: false,
})
export class NewsBannersComponent implements OnInit {
  newsBanners: NewsBannerModel[] = [];
  newsBannerSlides: NewsBannerSlideModel[] = [];
  isLoading: boolean = true;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private newsBannerService: NewsBannerService,
    private dialog: DialogService,
    private alertService: AlertService
  ) {}

  async ngOnInit(): Promise<void> {
    await this.fetchNewsBanners();
  }

  private async fetchNewsBanners(): Promise<void> {
    this.isLoading = true;
    return new Promise<void>(resolve => {
      this.newsBannerService
        .getAllNewsBanner()
        .pipe(take(1))
        .subscribe(newsBanners => {
          this.newsBanners = newsBanners;
          this.newsBannerSlides =
            this.newsBannerService.mapNewsBannersToSlides(newsBanners);

          this.isLoading = false;
          resolve();
        });
    });
  }

  navigateToCreateNewsBanner() {
    this.router.navigate(['create'], { relativeTo: this.activatedRoute });
  }

  navigateToEditNewsBanner(slide: NewsBannerSlideModel): void {
    const newsBannerId = slide.newsBannerId;

    const encodedNewsBannerId = btoa(newsBannerId.toString());
    this.router.navigate(['edit', encodeURIComponent(encodedNewsBannerId)], {
      relativeTo: this.activatedRoute,
    });
  }

  onDeleteNewsBanner(slide: NewsBannerSlideModel): void {
    const newsBannerId = slide.newsBannerId;

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '475px',
      contentStyle: { overflow: 'auto' },
      breakpoints: {
        '640px': '90vw',
      },
      data: {
        title: 'News Banner löschen',
        message:
          'Bist du sicher, dass du diesen News Banner löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.',
        icon: 'fa-regular fa-trash-can',
        iconColor: 'red',
        confirmButtonText: 'Löschen',
      },
    });

    dialogRef.onClose.pipe(take(1)).subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.isLoading = true;
        this.newsBannerService
          .deleteNewsBanner(newsBannerId)
          .pipe(take(1))
          .subscribe(async () => {
            await this.fetchNewsBanners();
            this.alertService.showSuccessAlert(
              'News Banner erfolgreich gelöscht'
            );
            this.isLoading = false;
          });
      }
    });
  }

  onNewsBannersChanged(reorderedNewsBanners: NewsBannerModel[]): void {
    this.newsBanners = reorderedNewsBanners;
    this.newsBannerSlides =
      this.newsBannerService.mapNewsBannersToSlides(reorderedNewsBanners);

    // Ensure array is replaced to trigger change detection
    this.newsBannerSlides = [...this.newsBannerSlides];
  }
}
